// src/components/AzureLoginButton.js
import React from "react";
import { message } from "antd";
import { UserAgentApplication } from "@azure/msal";
import { CONFIG } from "../../../service/Apiconfig";
import AuthService from "../../../service/AuthService.js";
import { Link,  } from "react-router-dom";
export default function AzureLoginButton(props) {
  const msalInstance = new UserAgentApplication({
    auth: {
      clientId: CONFIG.AZURE.CLIENT_ID,
      authority: "https://login.microsoftonline.com/common", // Multi-tenant
      redirectUri: CONFIG.AZURE.REDIRECT_URI
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true
    }
  });

  const handleLogin = async () => {
    try {
      // Step 1: Microsoft SSO popup (multi-tenant scopes)
      const loginResponse = await msalInstance.loginPopup({
        scopes: [
           "openid",
        "profile",
        "email",
         "User.Read", // ✅ Get email via Microsoft Graph
          `api://${CONFIG.AZURE.CLIENT_ID}/access_as_user`
        ]
      });

      console.log("Login response:", loginResponse);

      // Step 2: Acquire access token silently
      const tokenResponse = await msalInstance.acquireTokenSilent({
        scopes: [`api://${CONFIG.AZURE.CLIENT_ID}/access_as_user`]
      });

      const accessToken = tokenResponse.accessToken;

      if (!accessToken) {
        message.error("Failed to get access token.");
        return;
      }

      // Step 3: Send token to backend
     
      //console.log(accessToken);
       props.handleSSOLogin(accessToken);
    
    } catch (err) {
      message.error(err.message);
      console.error("Azure SSO error:", err);
    }
  };

  return (
     <Link
                    type="primary"
                    style={{
                      marginLeft: 14, // use comma, not semicolon; px is optional in React style
                      textDecoration: "underline", 
                    }}
                    to="#"
                    onClick={handleLogin} 
                  >
                     Login with SSO
                  </Link>

  );
}
